import React from 'react';
import SVG from 'react-inlinesvg';
import { getImageBaseUrl } from 'helpers/request';
import { Card, CardWrap, ChevronRightIcon, CardIcon } from './BikeFilters.styled';
import FilterDialog from './FilterDialog';

const FilterCard = ({ index, title, active, icon, type, values, description, onSelectCard, children }) => (
  <CardWrap active={active}>
    <Card active={active} onClick={() => (active ? onSelectCard(null) : onSelectCard(index))} thin>
      {icon ? (
        <CardIcon active={active}>
          <SVG src={getImageBaseUrl() + icon} alt={title} />
        </CardIcon>
      ) : null}
      {title}
      {children}
      <ChevronRightIcon />
    </Card>
    {active ? (
      <FilterDialog
        filterIndex={index}
        type={type}
        title={title}
        description={description}
        values={values}
        icon={icon}
      />
    ) : null}
  </CardWrap>
);

export default FilterCard;
